<template>
  <page :title="i18n.title">
    <div class="wallet-out-warp">
      <!-- <div class="wallet-out-title">{{$t('mine.deposit')}}</div> -->
      <div class="wallet-out-prices-warp">
        <div class="wallet-label">
          <span>{{user.pcurrencyName}}</span>
          <span class="label-theme">{{user.p_balance}}</span>
        </div>
      </div>
      <div class="wallet-out-items">
        <div class="wallet-out-item" @click="type = 1">
          <div :class="{'is-select': type === 1}"></div>
          <span>{{i18n.type1}}</span>
          <image src="../../static/icons/wallet_out1.png" mode=""></image>
        </div>
        <!-- <div class="wallet-out-item" @click="type = 2">
          <div :class="{'is-select': type === 2}"></div>
          <span>{{i18n.type2}}</span>
          <image src="../../static/icons/wallet_out2.png" mode=""></image>
        </div>
        <div class="wallet-out-item" @click="type = 3">
          <div :class="{'is-select': type === 3}"></div>
          <span>{{i18n.type3}}</span>
          <image src="../../static/icons/wallet_out3.png" mode=""></image>
        </div> -->
      </div>
      <div class="wallet-out-tips">
        <div>{{i18n.tips_title}}</div>
        <span>{{i18n.tips1}}</span>
      </div>
      <!-- <div v-if="type === 2" class="wallet-out-prices-warp">
        <div class="wallet-out-input">
          <span>{{i18n.input1}}</span>
          <input type="span" v-model="phone" />
        </div>
      </div>
      <div v-if="type === 3">
        <div class="wallet-out-prices-warp">
          <div class="wallet-out-input">
            <span>{{i18n.input2}}</span>
            <input type="span" v-model="bank" />
          </div>
        </div>
        <div class="wallet-out-prices-warp">
          <div class="wallet-out-input">
            <span>{{i18n.input3}}</span>
            <input type="span" v-model="subbranch" />
          </div>
        </div>
        <div class="wallet-out-prices-warp">
          <div class="wallet-out-input">
            <span>{{i18n.input4}}</span>
            <input type="span" v-model="name" />
          </div>
        </div>
      </div> -->
      <div class="wallet-btn">
        <button class="btn" @click="onSubmit">{{i18n.btn}}</button>
      </div>
    </div>
  </page>
</template>

<script>
import { USER_INFO } from '../../apis/user.js'
import { TIXIAN_RECHARGE } from '../../apis/payment.js'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['user', 'locale']),
    i18n () {
      return this.$t('wallet_out')
    },
    i18nMsg () {
      return this.$t('msg')
    }
  },
  data () {
    return {
      price: 0,
      type: 1,
      phone: '',
      bank: '',
      subbranch: '',
      name: ''
    }
  },
  methods: {
    onAll () {
      if (this.user && this.user.pbalance) {
        this.price = this.user.pbalance
      }
    },
    onSubmit () {
      if (this.user.p_balance <= 0) {
        this.$toast(this.i18n.msg_fail_price)
      } else {
        this.$loading(true)
        if (this.type === 1) {
          this.onTiXian()
        } else {
          this.onApply()
        }
      }
    },
    onTiXian () {
      this.$post(
        TIXIAN_RECHARGE,
        {
          amount: this.user.p_balance
        },
        res => {
          this.$loading(false)
          this.$toast(res.msg)
          this.loadUser()
        },
        err => {
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onApply () {
      let remark = ''
      if (this.type === 2) {
        if (!this.phone) {
          this.$loading(false)
          this.$toast(this.i18n.error_tips)
          return
        } else {
          remark = this.i18n.input1 + this.phone
        }
      }
      if (this.type === 3) {
        if (!this.bank || !this.subbranch || !this.name) {
          this.$loading(false)
          this.$toast(this.i18n.error_tips)
          return
        } else {
          remark = `${this.i18n.input2}${this.bank};${this.i18n.input3}${this.subbranch};${this.i18n.input4}${this.name};`
        }
      }
      this.$post(
        TIXIAN_RECHARGE,
        {
          amount: this.user.p_balance,
          remark: remark
        },
        res => {
          this.$loading(false)
          this.$toast(res.msg)
          this.loadUser()
        },
        err => {
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    loadUser () {
      this.$get(
        USER_INFO,
        {},
        resp => {
          if (resp.user) {
            this.$store.commit('user', resp.user)
          } else {
            this.$confirm({
              title: this.$t('mine.msg_fail_title'),
              content: this.$t('mine.msg_fail_user'),
              // confirmText: this.i18nMsg.retry,
              showOk: false,
              cancelText: this.i18nMsg.cancel
            }).then(() => {
              this.loadUser()
            })
          }
        },
        error => {
          this.$confirm({
            title: this.$t('mine.msg_fail_title'),
            content: this.i18nMsg.error,
            // confirmText: this.i18nMsg.retry,
            showOk: false,
            cancelText: this.i18nMsg.cancel
          }).then(() => {
            this.loadUser()
          })
          console.log(error)
        }
      )
    }
  }
}
</script>

<style lang="less">
.wallet-out-warp {
  padding: 32px;
  background-image: url(../../assets/imgs/icon_top.png);
  background-repeat:no-repeat;
  background-size: 100% 28%;
}
.wallet-out-title {
  color: #FFFFFF;
  font-size: 48px;
  padding: 110px 40px 0;
}
.wallet-form{
  background: #FFFFFF;
  padding: 40px 40px 0;
}
.wallet-label{
  font-size: 60px;
  font-weight: 400;
  color: #3c80fa;
  text-align: center;
  padding: 60px 0;
  .label-theme {
    padding-left: 12px;
  }
}

.wallet-input{
  padding-top: 20px;
  display: flex;
  align-items: center;
  font-size: 56px;
  font-weight: 500;
  color:rgba(52,125,255,1);
}
.wallet-input span{
  height: 78px;
  line-height: 78px;
}
.wallet-input input{
  flex: 1;
  height: 78px;
  line-height: 78px;
}
.wallet-balance{
  background: #FFFFFF;
  border-top: 1px solid rgba(217,217,217,1);
  font-size: 32px;
  font-weight: 400;
  color: rgba(51,51,51,1);
  padding: 26px 40px;
  display: flex;
  align-items: center;
}
.wallet-balance span{
  font-size: 30px;
  font-weight: 400;
  color:rgba(52,125,255,1);
}
.wallet-balance span.price{
  flex: 1;
  font-size: 36px;
  font-weight: 500;
  color: rgba(241,52,52,1);
}
.wallet-deposit{
  background: #FFFFFF;
  margin-top: 20px;
  padding: 26px 40px;
}
.wallet-btn{
  padding: 55px;
}
.wallet-out-prices-warp{
  margin-top: 40px;
  background: #FFFFFF;
  padding: 8px 40px;
  font-size: 32px;
  font-weight: 400;
  color: #5E5E66;
  border-radius: 10px;
  box-shadow: 0 6px 16px rgba(125,146,196,0.4);
}
.wallet-out-items {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  color: #67676f;
  padding: 40px 20px;
  .wallet-out-item {
    display: flex;
    justify-content: center;
    align-items: center;
    div {
      width: 18px;
      height: 18px;
      border: 3px solid #67676f;
      border-radius: 50%;
      margin: 0 6px;
    }
    image {
      width: 26px;
      height: 26px;
      margin: 0 6px;
    }
    span {
      display: inline-block;
      height: 52px;
      line-height: 52px;
      padding: 0 24px;
      color: #FFFFFF;
      background-color: #b8045b;
      border-radius: 40px;
    }
    .is-select {
      background-color: #88ce09;
    }
  }
}
.wallet-out-tips {
  font-size: 24px;
  color: #67676f;
  line-height: 56px;
  padding: 0 20px;
  div {
    color: #b8045b;
  }
}
.wallet-out-input {
  font-size: 24px;
  color: #67676f;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  span {
    padding-right: 10px;
  }
  input {
    flex: 1;
    height: 70px;
    line-height: 70px;
  }
}
</style>
